import { IOrganization, Organization } from "@/services/DTOs/Organization";
import { OpportunitiesApiService } from "@/services/OpportunitiesApiService";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Person } from "./DTOs";

class Service {

  public search(query: string, limit: number = 10, canary: boolean | Person | undefined): Observable<Organization[]> {
    const url = "/api/suite/organizations";
    const params = new URLSearchParams();

    canary = typeof canary === "object" ? canary.canary : canary ? canary : false;

    params.append("q", query);
    params.append("limit", limit.toString());
    params.append("canary", canary.toString());

    return OpportunitiesApiService.cancellableGet(url, params)
      .pipe(
        map((response) => response.data.map((o: IOrganization) => new Organization(o)))
      );
  }

}

export const OrganizationsService = new Service();
